import './TypeBranding.css';
import { useTranslation } from "react-i18next";

function TypeBranding() {

    const { t } = useTranslation();

    return (

        <>

          <div className="Container-WhyUs">

            <div className="Container-WhyUs-left">
                <h1>{t("Branding.TypeBranding.BigTitle")}</h1>
            </div>

            <div className="Container-WhyUs-right">

                {/* Bloc 1 */}
                <div className="Container-WhyUs-right-content">
                    <div className="Container-WhyUs-right-title">
                        {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.Title")}
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine1")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine2")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine3")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine4")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine5")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine6")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine7")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine8")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine9")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.1ArtistsMusiciansPerformers.ContentLine10")}
                            </p>
                        </div>
                    </div>
                </div>

                {/*---------------------------------------------------*/}

                {/* Bloc 1 */}
                <div className="Container-WhyUs-right-content">
                    <div className="Container-WhyUs-right-title">
                        {t("Branding.TypeBranding.2WeddingsLuxuryEvents.Title")}
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine1")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine2")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine3")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine4")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine5")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine6")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine7")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine8")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine9")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine10")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.2WeddingsLuxuryEvents.ContentLine11")}
                            </p>
                        </div>
                    </div>
                </div>

                {/*------------------------------------------------------------*/}

                {/* Bloc 1 */}
                <div className="Container-WhyUs-right-content">
                    <div className="Container-WhyUs-right-title">
                        {t("Branding.TypeBranding.3LifestyleSportsContentCreators.Title")}
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine1")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine2")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine3")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine4")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine5")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine6")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine7")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine8")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.3LifestyleSportsContentCreators.ContentLine9")}
                            </p>
                        </div>
                    </div>
                </div>

                {/*------------------------------------------------------------*/}

                {/* Bloc 2 */}
                <div className="Container-WhyUs-right-content">
                    <div className="Container-WhyUs-right-title">
                        {t("Branding.TypeBranding.4BeautyFashionStyleBrand.Title")}
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine1")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine2")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine3")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine4")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine5")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine6")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine7")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine8")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine9")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.4BeautyFashionStyleBrand.ContentLine10")}
                            </p>
                        </div>
                    </div>
                </div>

                {/*------------------------------------------------------------*/}

                {/* Bloc 2 */}
                <div className="Container-WhyUs-right-content-x">
                    <div className="Container-WhyUs-right-title">
                        {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.Title")}
                    </div>
                    <div className="Container-WhyUs-right-paragraf">
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine1")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine2")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine3")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine4")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine5")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine6")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine7")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine8")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine9")}
                            </p>
                        </div>
                        <div className="icon-text">
                            <i className="fa-solid fa-circle-check"></i>
                            <p>
                                {t("Branding.TypeBranding.5BusinessHospitalityRealEstate.ContentLine10")}
                            </p>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        </>
    );
}

export default TypeBranding;
